import { useTranslation } from 'react-i18next';
import { AccountFundingOption, FieldData, formattedCurrency } from 'vopay';
import { PaymentFieldDefault } from './types';
import { useFundingOptionField } from './useFundingOptionField';

export const usePayFromFields = (
  fundingOptions: AccountFundingOption[],
  isFetchingFundingOptions: boolean,
): FieldData<PaymentFieldDefault>[] => {
  const { t } = useTranslation('translations', { keyPrefix: 'UseTransactionCreationFields' });

  const getSubtitle = (option: AccountFundingOption) => {
    if (option.Source === 'balance') {
      return `${option.Currency} ${formattedCurrency(option.AvailableFunds || option.AccountBalance || '0')}`;
    }
    return t('Fields.PayFrom.fundThenPay', { defaultValue: 'Fund the balance first, then pay' });
  };

  return useFundingOptionField(fundingOptions, isFetchingFundingOptions, {
    fieldName: 'PayFrom',
    translationPrefix: 'PayFrom',
    labelDefaultValue: 'Pay From',
    showFee: true,
    showSettlementTime: true,
    showBalanceInlineSubtitle: true,
    getSubtitle,
  });
};
